var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27038_2286)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6287 0.75C14.0265 0.75 14.408 0.908033 14.6894 1.18934L16.8106 3.31066C17.092 3.59197 17.25 3.97349 17.25 4.37132V15C17.25 16.2427 16.2427 17.25 15 17.25H3C1.75736 17.25 0.75 16.2427 0.75 15V3C0.75 1.75736 1.75736 0.75 3 0.75H13.6287ZM3 2.25C2.58579 2.25 2.25 2.58579 2.25 3V15C2.25 15.4142 2.58579 15.75 3 15.75H3.75V11.25C3.75 10.0073 4.75736 9 6 9H12C13.2427 9 14.25 10.0073 14.25 11.25V15.75H15C15.4142 15.75 15.75 15.4142 15.75 15V5.12132C15.75 4.72349 15.592 4.34197 15.3106 4.06066L13.9394 2.68934C13.658 2.40803 13.2765 2.25 12.8787 2.25H12.75V3.75C12.75 4.99264 11.7427 6 10.5 6H7.5C6.25736 6 5.25 4.99264 5.25 3.75V2.25H3ZM12.75 15.75V11.25C12.75 10.8358 12.4142 10.5 12 10.5H6C5.58579 10.5 5.25 10.8358 5.25 11.25V15.75H12.75ZM6.75 2.25H11.25V3.75C11.25 4.16421 10.9142 4.5 10.5 4.5H7.5C7.08579 4.5 6.75 4.16421 6.75 3.75V2.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27038_2286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.da2c33c767b6641ad71c8f7d0022273e.svg";
export { ForwardRef as ReactComponent };